import AaPanelLogo from '~/assets/images/aapanel-logo.png';
import AdminboltLogo from '~/assets/images/adminbolt-logo.svg';
import {
  default as AlmaLinux,
  default as AlpineLogo,
  default as AmazonLogo,
  default as ArchLogo,
} from '~/assets/images/alma-linux.svg';
import BmadLogo from '~/assets/images/bmad-logo.png';
import CentOSLogo from '~/assets/images/centOS.svg';
import ChatwootLogo from '~/assets/images/chatwoot-logo.svg';
import ClaudeCodeLogo from '~/assets/images/claudecode-logo.svg';
import CloudPanelLogo from '~/assets/images/cloudpanel-logo.svg';
import CloudronLogo from '~/assets/images/cloudron-logo.svg';
import CoolifyLogo from '~/assets/images/coolify-logo.svg';
import CpanelLogo from '~/assets/images/cpanel-logo.svg';
import CyberPanelLogo from '~/assets/images/cyberpanel-logo.svg';
import DebianLogo from '~/assets/images/debian.svg';
import DeepseekLogo from '~/assets/images/deepseek-logo.svg';
import DifyLogo from '~/assets/images/dify-logo.svg';
import EasyPanelLogo from '~/assets/images/easypanel-logo.svg';
import FedoraLogo from '~/assets/images/fedora.svg';
import GatorClaw from '~/assets/images/gator-claw.png';
import GhostLogo from '~/assets/images/ghost-logo.svg';
import GstackLogo from '~/assets/images/gstack-logo.png';
import HermesAgentLogo from '~/assets/images/hermesagent-logo.svg';
import HestiaLogo from '~/assets/images/hestia-logo.svg';
import IspConfigLogo from '~/assets/images/ispconfig-logo.svg';
import JitsiLogo from '~/assets/images/jitsi-logo.svg';
import LampLogo from '~/assets/images/LAMP.svg';
import LangflowLogo from '~/assets/images/langflow-logo.svg';
import Magento from '~/assets/images/magento.png';
import MoodleLogo from '~/assets/images/moodle-logo.svg';
import N8nLogo from '~/assets/images/n8n-logo.svg';
import NanoclawLogo from '~/assets/images/nanoclaw-logo.svg';
import NginxLogo from '~/assets/images/nginx-logo.svg';
import OdooLogo from '~/assets/images/odoo-logo.svg';
import OllamaLogo from '~/assets/images/ollama-logo.svg';
import ClawLogo from '~/assets/images/open-claw.svg';
import OpenLiteSpeedNodeJsLogo from '~/assets/images/openlitespeed-nodejs-logo.svg';
import OpenLiteSpeedWordpressLogo from '~/assets/images/openlitespeed-wordpress-logo.svg';
import OpenWebUiLogo from '~/assets/images/openwebui-logo.svg';
import PaperclipLogo from '~/assets/images/paperclip-logo.svg';
import PortainerLogo from '~/assets/images/portainer-logo.svg';
import RocketChatLogo from '~/assets/images/rocket-chat-logo.svg';
import RockyLogo from '~/assets/images/rocky-linux.svg';
import SimLogo from '~/assets/images/sim-logo.png';
import UbuntuLogo from '~/assets/images/ubuntu.svg';
import WebadminLogo from '~/assets/images/webadmin-logo.svg';
import WebuzoLogo from '~/assets/images/webuzo-logo.png';
import WooCommerceLogo from '~/assets/images/woocommerce-logo.svg';
import WordpressLogo from '~/assets/images/wordpress-icon.svg';

export interface LogoConfig {
  logo: string;
  logoAlt: string;
}

const HERMES_AGENT_LOGO: LogoConfig = {
  logo: HermesAgentLogo,
  logoAlt: 'Hermes Agent Logo',
};

const OPEN_WEBUI_LOGO: LogoConfig = {
  logo: OpenWebUiLogo,
  logoAlt: 'Open WebUI Logo',
};

const HESTIA_LOGO: LogoConfig = {
  logo: HestiaLogo,
  logoAlt: 'Hestia Logo',
};

const LOGO_MAP: Record<string, LogoConfig> = {
  // OS logos
  alma: { logo: AlmaLinux, logoAlt: 'AlmaLinux Logo' },
  centos: { logo: CentOSLogo, logoAlt: 'CentOS Logo' },
  debian: { logo: DebianLogo, logoAlt: 'Debian Logo' },
  ubuntu: { logo: UbuntuLogo, logoAlt: 'Ubuntu Logo' },
  fedora: { logo: FedoraLogo, logoAlt: 'Fedora Logo' },
  rocky: { logo: RockyLogo, logoAlt: 'Rocky Linux Logo' },
  alpine: { logo: AlpineLogo, logoAlt: 'Alpine Linux Logo' },
  amazon: { logo: AmazonLogo, logoAlt: 'Amazon Linux Logo' },
  arch: { logo: ArchLogo, logoAlt: 'Arch Linux Logo' },
  // App logos
  aapanel: { logo: AaPanelLogo, logoAlt: 'aaPanel Logo' },
  adminbolt: { logo: AdminboltLogo, logoAlt: 'AdminBolt Logo' },
  bmad: { logo: BmadLogo, logoAlt: 'BMAD Logo' },
  chatwoot: { logo: ChatwootLogo, logoAlt: 'Chatwoot Logo' },
  claudecode: { logo: ClaudeCodeLogo, logoAlt: 'Claude Code Logo' },
  cloudpanel: { logo: CloudPanelLogo, logoAlt: 'CloudPanel Logo' },
  cloudron: { logo: CloudronLogo, logoAlt: 'Cloudron Logo' },
  coolify: { logo: CoolifyLogo, logoAlt: 'Coolify Logo' },
  cpanel: { logo: CpanelLogo, logoAlt: 'cPanel Logo' },
  cyberpanel: { logo: CyberPanelLogo, logoAlt: 'CyberPanel Logo' },
  deepseek: { logo: DeepseekLogo, logoAlt: 'DeepSeek Logo' },
  dify: { logo: DifyLogo, logoAlt: 'Dify Logo' },
  easypanel: { logo: EasyPanelLogo, logoAlt: 'EasyPanel Logo' },
  ghost: { logo: GhostLogo, logoAlt: 'Ghost Logo' },
  gstack: { logo: GstackLogo, logoAlt: 'GStack Logo' },
  gatorclaw: { logo: GatorClaw, logoAlt: 'GatorClaw Logo' },
  hermes: HERMES_AGENT_LOGO,
  hermesagent: HERMES_AGENT_LOGO,
  hermesopenwebui: OPEN_WEBUI_LOGO,
  hestia: HESTIA_LOGO,
  hestiacp: HESTIA_LOGO,
  ispconfig: { logo: IspConfigLogo, logoAlt: 'ISPConfig Logo' },
  jitsi: { logo: JitsiLogo, logoAlt: 'Jitsi Logo' },
  lamp: { logo: LampLogo, logoAlt: 'LAMP Stack Logo' },
  langflow: { logo: LangflowLogo, logoAlt: 'Langflow Logo' },
  lemp: { logo: NginxLogo, logoAlt: 'LEMP Stack Logo' },
  magento: { logo: Magento, logoAlt: 'Magento Logo' },
  moodle: { logo: MoodleLogo, logoAlt: 'Moodle Logo' },
  n8n: { logo: N8nLogo, logoAlt: 'n8n Logo' },
  nanoclaw: { logo: NanoclawLogo, logoAlt: 'Nanoclaw Logo' },
  odoo: { logo: OdooLogo, logoAlt: 'Odoo Logo' },
  ollama: { logo: OllamaLogo, logoAlt: 'Ollama Logo' },
  openclaw: { logo: ClawLogo, logoAlt: 'OpenClaw Logo' },
  openlitespeednodejs: {
    logo: OpenLiteSpeedNodeJsLogo,
    logoAlt: 'OpenLiteSpeed Node.js Logo',
  },
  openlitespeedwordpress: {
    logo: OpenLiteSpeedWordpressLogo,
    logoAlt: 'OpenLiteSpeed WordPress Logo',
  },
  openwebui: OPEN_WEBUI_LOGO,
  paperclip: { logo: PaperclipLogo, logoAlt: 'Paperclip Logo' },
  portainer: { logo: PortainerLogo, logoAlt: 'Portainer Logo' },
  rocketchat: { logo: RocketChatLogo, logoAlt: 'Rocket.Chat Logo' },
  sim: { logo: SimLogo, logoAlt: 'Sim Logo' },
  webadmin: { logo: WebadminLogo, logoAlt: 'WebAdmin Logo' },
  webuzo: { logo: WebuzoLogo, logoAlt: 'Webuzo Logo' },
  woocommerce: { logo: WooCommerceLogo, logoAlt: 'WooCommerce Logo' },
  wordpress: { logo: WordpressLogo, logoAlt: 'WordPress Logo' },
};

const toLogoLookupKey = (key: string) =>
  key.toLowerCase().replace(/[\s_-]+/g, '');

export const getLogoConfig = (key?: string | null): LogoConfig => {
  const normalized = key?.toLowerCase();
  if (normalized && normalized in LOGO_MAP) {
    return LOGO_MAP[normalized];
  }

  const compact = key ? toLogoLookupKey(key) : '';
  if (compact && compact in LOGO_MAP) {
    return LOGO_MAP[compact];
  }

  const fallback = key?.slice(0, 2)?.toUpperCase();
  return {
    logo: fallback ?? '',
    logoAlt: fallback ? `Default Logo (${fallback})` : '',
  };
};

export const getImageLinks = (
  links?: {
    doc?: string | null;
    forums?: string | null;
    community?: string | null;
  } | null,
) => ({
  docsUrl: links?.doc ?? undefined,
  forumUrl: links?.forums ?? undefined,
  communityUrl: links?.community ?? undefined,
});
